/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
	| T
	| {
			[P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
	  };
import type * as Types from '../../../gql/types-mutations';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type ValidateTurnstileQueryVariables = Exact<{
	token: string;
}>;

export type ValidateTurnstileQuery = {
	validateTurnstile: {
		success: boolean;
		messages: Array<string>;
		errorCodes: Array<string>;
	} | null;
};

export const ValidateTurnstileDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'ValidateTurnstile' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'token' },
					},
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'String' },
						},
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'validateTurnstile' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'token' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'token' },
								},
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'success' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'messages' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'errorCodes' } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	ValidateTurnstileQuery,
	ValidateTurnstileQueryVariables
>;
